import React, { useEffect, useState } from 'react';
import { Fab, Tooltip, Zoom } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useTranslation } from 'react-i18next';
import { SITE } from '../config/site';

export default function WhatsAppFab() {
  const { t } = useTranslation();
  const label = t('whatsapp.chat', { defaultValue: 'Chat with us on WhatsApp' });

  // Hold the FAB back until the hero has mostly scrolled away, then let it
  // scale in — so it joins once the visitor is browsing, not at first paint.
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Zoom in={show} unmountOnExit>
      <Tooltip title={label} placement="left">
        <Fab
          component="a"
          href={SITE.whatsappUrl(
            t('whatsapp.prefilled', {
              defaultValue: 'Hi Hawrat, I have a question about your collection.',
            })
          )}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          sx={{
            position: 'fixed',
            bottom: { xs: 16, md: 24 },
            right: { xs: 16, md: 24 },
            bgcolor: '#25D366',
            color: '#fff',
            zIndex: 1300,
            boxShadow: '0 6px 20px rgba(37, 211, 102, 0.45)',
            '&:hover': { bgcolor: '#1ebe57' },
            // A few gentle rings ripple out shortly after the FAB appears,
            // then it settles — a nudge toward chat without nagging.
            '@media (prefers-reduced-motion: no-preference)': {
              '&::after': {
                content: '""',
                position: 'absolute',
                inset: 0,
                borderRadius: '50%',
                border: '2px solid #25D366',
                pointerEvents: 'none',
                animation: 'waRing 2.2s ease-out 1s 3',
              },
            },
            '@keyframes waRing': {
              '0%': { transform: 'scale(1)', opacity: 0.55 },
              '100%': { transform: 'scale(1.85)', opacity: 0 },
            },
          }}
        >
          <WhatsAppIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
}
